export default __webpack_public_path__ + "static/media/logo-horizontal.3357aac0.png";